// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withFlux } from '@homie/flux';
import AppStore from 'stores/AppStore';
import {
  StyledHeader,
  Paragraph,
  OwnerBenefitsContainer,
  OwnerBenefits,
  OwnerBgContainer,
  OwnerIndexContainer
} from './styles';
import ReportView from './ReportView';

type OwnerIndexProps = {
  history: any,
  match: any,
  currentUser: any
};

const OwnerIndex = ({ history, match, currentUser }: OwnerIndexProps) => {
  const { homeApplicationId } = match.params;
  return (
    <OwnerIndexContainer>
      <ReportView homeApplicationId={homeApplicationId} history={history} />
      <OwnerBenefitsContainer>
        <OwnerBenefits>
          <StyledHeader marginBottom={40} type="primary">
            Beneficios de ser un propietario Homie
          </StyledHeader>
          <Paragraph marginBottom={40}>
            Despreocúpate por tu inquilino, nosotros nos encargamos de cobrar la
            renta, te <strong>garantizamos el pago puntual</strong> y{' '}
            <strong>te protegemos jurídicamente</strong>
          </Paragraph>
          <Paragraph>
            <strong>
              ¡Te regalamos 3 meses de nuestro servicio para que lo pruebes!
            </strong>{' '}
            Renta en menos de 24 horas y con la mejor protección
          </Paragraph>
        </OwnerBenefits>
        <OwnerBgContainer>
          <img src="/assets/external-tenant/owner-bg.svg" />
        </OwnerBgContainer>
      </OwnerBenefitsContainer>
    </OwnerIndexContainer>
  );
};

export default withFlux([AppStore], () => ({
  currentUser: AppStore.getCurrentUser()
}))(withRouter(OwnerIndex));
